import moment from "jalali-moment";
import React from "react";
import { Button, Modal, SelectInput } from "../../../_components";
import "../css/copy-data-modal.scss";

const operationTypeOptions = [
  { name: "instructions", label: "دستور العمل ها" },
  { name: "policies", label: "سیاست خط مشی" },
  { name: "checklists", label: "چک لیست ها" },
  { name: "digital_library", label: "کتابخانه دیجیتال" },
  { name: "menus", label: "منو ها" },
  { name: "indicators", label: "شاخص ها" },
  { name: "programs", label: "برنامه ها" },
];

const calcNumbersAround = () => {
  const currentYear = moment().jYear();
  const startYear = 1394;
  return Array.from(
    { length: currentYear + 10 - startYear + 1 },
    (_, i) => startYear + i
  ).map((year) => ({
    label: year.toString(),
    name: year.toString(),
  }));
};

export const CopyDataModal = ({
  onClose,
  isLoading,
  submit,
  formValues,
  onChangeForm,
}) => {
  const yearOptions = calcNumbersAround();

  return (
    <Modal
      isOpen={true}
      title="کپی اطلاعات"
      onClose={onClose}
      className="copy_data_modal"
    >
      <SelectInput
        title="نوع کپی اطلاعات را مشخص کنید"
        placeholder="نوع اطلاعات را مشخص کنید"
        onChange={(ob) => onChangeForm("operationType", ob.name)}
        value={{
          label:
            formValues.operationType &&
            operationTypeOptions.find(
              (option) => option.name === formValues.operationType
            ).label,
          name: formValues.operationType,
        }}
        options={operationTypeOptions}
      />
      <SelectInput
        title="سال مبدا اطلاعات"
        placeholder="سال مبدا را مشخص کنید"
        onChange={(ob) => onChangeForm("fromYear", ob.name)}
        value={{
          label: formValues.fromYear,
          name: formValues.fromYear,
        }}
        options={yearOptions}
        containerClassName="mt-3"
      />
      <SelectInput
        title="سال مقصد اطلاعات"
        placeholder="سال مقصد را مشخص کنید"
        onChange={(ob) => onChangeForm("toYear", ob.name)}
        value={{
          label: formValues.toYear,
          name: formValues.toYear,
        }}
        options={yearOptions}
        containerClassName="mt-3"
      />
      <div className="submit_parent">
        <Button isLoading={isLoading} className="submit_btn" onClick={submit}>
          بروز رســانی
        </Button>
        <Button
          isLoading={isLoading}
          className="close_btn"
          variant="outlined"
          onClick={onClose}
        >
          انصراف
        </Button>
      </div>
    </Modal>
  );
};
